import { render, staticRenderFns } from "./ReportFiltersConfig.vue?vue&type=template&id=66560686&scoped=true&"
import script from "./ReportFiltersConfig.vue?vue&type=script&lang=js&"
export * from "./ReportFiltersConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66560686",
  null
  
)

export default component.exports